

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { KbaResponse } from '../model/kbaresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { KnowledgeBaseFilterInfo } from '../model/knowledgebasefilterinfo';
import { Observable } from 'rxjs';

@Injectable()
export class KbaService {

    constructor(public http: HttpClient) {
    }

    // function call to fetch kba list
    public getKbaList(offset: number, limit: number, sortBy: string, sortOrder: string, kbaFilter: KnowledgeBaseFilterInfo) {
        const params = new HttpParams()
        .set('offset', offset.toString())
        .set('limit', limit.toString())
        .set('sortBy', sortBy)
        .set('sortOrder', sortOrder);
        return this.http.post<KbaResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/kbas', kbaFilter, {params});
        }

    public getItemCategories() {
        const params = new HttpParams()
        .set('itemOption', 'ALL');
        return this.http.get<ItemCategoriesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allCategories', {params});
    }

    public getItemTypes() {
        const params = new HttpParams()
        .set('itemOption', 'ALL');
        return this.http.get<ItemTypesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allItemTypes', {params});
    }

    public increaseViewCount(kbaId: number): Observable<number> {
         return this.http.post<number>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/kbas/' + kbaId + '/view', null);
    }
}
